<h1 class="form-title form-title__bp_lt-md_center">
  {{ 'remeber.form.title' | translate }}
</h1>

<form [formGroup]="form" (submit)="onSubmit()" novalidate>
  <app-custom-input-text
    label="register.form.email"
    placeholder="register.form.email"
    key="email"
    type="text"
    [control]="form.get('email')"
    [submitted]="!form.get('email')?.pristine"
    [errorsList]="errorFeedbackList.email">
  </app-custom-input-text>

  <app-button
    class="ind-btn-wrapper-100"
    type="submit"
    label="buttons.labels.remember-my-password"
    [isDisabled]="form && !form.valid">
  </app-button>

  <app-button
    class="back ind-btn-wrapper-100"
    className="ind-btn--primary"
    label="support.buttons.back"
    [routerLink]="loginPath"></app-button>
</form>
